import React from 'react';
import { useNavigate } from 'react-router-dom';
import OrganizationSettingsPanel from '../components/features/settings/OrganizationSettingsPanel';

/**
 * Organization settings as a routed page (/organization). The panel self-wraps in
 * AppLayout (shared sidebar) when not in modal mode, so this is a thin wrapper —
 * it just supplies an `onBack` that returns to the previous page.
 */
const OrganizationPage: React.FC = () => {
  const navigate = useNavigate();
  return <OrganizationSettingsPanel onBack={() => navigate(-1)} />;
};

export default OrganizationPage;
